import { useLocation, useNavigate } from '@tanstack/react-router';
import { Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { useCurrentRef } from 'src/react/_hooks/useCurrentRef';

export const useSearchSynced = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => {
    const params = new URLSearchParams();
    for (const [k, v] of Object.entries(search as Record<string, string>)) {
      if (v !== undefined && v !== null) params.set(k, String(v));
    }
    return params;
  }, [search]);
  const searchParamsCurrent = useCurrentRef(searchParams);

  const setSearchParams: Dispatch<SetStateAction<URLSearchParams>> = useCallback(
    (value) => {
      if (typeof value === 'function') {
        // eslint-disable-next-line react-hooks/immutability
        searchParamsCurrent.current = value(searchParamsCurrent.current);

        navigate({
          // biome-ignore lint/suspicious/noExplicitAny: TanStack Router search params typing
          search: Object.fromEntries(searchParamsCurrent.current.entries()) as any,
        });
      } else {
        searchParamsCurrent.current = value;

        // biome-ignore lint/suspicious/noExplicitAny: bypass
        navigate({ search: Object.fromEntries(value.entries()) as any });
      }
    },
    [navigate, searchParamsCurrent]
  );

  return [searchParams, setSearchParams] as const;
};
